import React, { Component } from 'react';

class Header extends Component {
  render() {
    const { color, logo, name } = this.props.headerData;
    const bgStyle = { backgroundColor: color };

    let content = name;
    if (logo) {
      content = (
        <img
          className="headerLogo"
          onClick={() =>
            this.props.history.push(
              `/${this.props.match.params.guide_slug}/gift_certificates`
            )
          }
          src={logo}
          alt={name}
        />
      );
    }

    return (
      <div className="desktopHeader" style={bgStyle}>
        {content}
      </div>
    );
  }
}

export default Header;
